import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import { SettingsItem } from 'design-system';
import { IconEdit, IconSmartRule, IconTrash } from 'design-system/icons';
import IconBlock from 'design-system/icons/IconBlock';
export const SmartRuleMenuModal = {
    show: ({ onEdit, onDeactivate, onActivate, onDelete, isActive }) => {
        Modal.show(<>
        {isActive ? (<>
            <SettingsItem title="Edit rule" description="The changes will apply to future transactions" onPress={() => SmartRuleMenuModal.hide(onEdit)} icon={<IconEdit colorKey="brand"/>}/>
            <SettingsItem title="Deactivate rule" description="This will pause the rule and you can reactivate it anytime" onPress={() => {
                    SmartRuleMenuModal.hide(() => {
                        Modal.showConfirmation({
                            title: 'Deactivate smart rule',
                            subtitle: 'Are you sure you want to deactivate this Smart Rule? You’ll still be able to view inactive rules using the button at the bottom of the Smart Rules list.',
                            confirmButtonTitle: 'Cancel',
                            cancelButtonTitle: 'Deactivate',
                            onPressCancel: onDeactivate,
                        });
                    });
                }} icon={<IconBlock colorKey="secondary"/>}/>
          </>) : (<SettingsItem title="Activate rule" description="You can edit the rule anytime after activation if needed" onPress={() => {
                    SmartRuleMenuModal.hide();
                    onActivate();
                }} icon={<IconSmartRule />}/>)}
        <SettingsItem title="Delete rule" description="It cannot be undone. Transactions already created by this rule will remain" onPress={() => {
                SmartRuleMenuModal.hide(() => {
                    Modal.showConfirmation({
                        title: 'Delete smart rule',
                        subtitle: 'Are you sure you want to delete this Smart Rule? Transactions already created by this rule will remain.\n\nIf you might need this rule later, consider deactivating it instead—you can reactivate it anytime.',
                        confirmButtonTitle: 'Cancel',
                        cancelButtonTitle: 'Delete',
                        onPressCancel: onDelete,
                    });
                });
            }} icon={<IconTrash colorKey="negative"/>}/>
      </>, {
            containerStyle: styles.modal,
            title: 'Manage rule',
        });
    },
    hide: (onDidHideCallback) => {
        Modal.hide(onDidHideCallback);
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
    },
});
